import { render, staticRenderFns } from "./LabelApiStatistics.vue?vue&type=template&id=32e3e2a2&"
import script from "./LabelApiStatistics.vue?vue&type=script&lang=js&"
export * from "./LabelApiStatistics.vue?vue&type=script&lang=js&"
import style0 from "./LabelApiStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports